import { render, staticRenderFns } from "./RecordSocialServiceView.vue?vue&type=template&id=a7bc0552&"
import script from "./RecordSocialServiceView.vue?vue&type=script&lang=js&"
export * from "./RecordSocialServiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports